export default "__VITE_ASSET__c0c17375__"